















import {Component, Vue, Prop, Emit, Watch} from 'vue-property-decorator';

@Component
export default class FarmTagsChips extends Vue {
    @Prop({default: ''}) public tags!: string;

    get tagList() {
        return this.tags.split(' ');
    }
}
